import React, {useRef} from 'react';
import Button from '../layout/Button';
import AssetPicker from '../filebrowser/AssetPicker2';
import SceneObjectPicker from '../SceneObjectPicker'
import ModalManager from '../layout/ModalManager';
import PropertyBase from '../properties/PropertyBase';
import TabbedDisplay from '../layout/TabbedDisplay';
import Panel from '../layout/Panel';
import AssetUtility from '../../classes/AssetUtility';
import Utils from '../../classes/Utilities';
import Scenario from '../../classes/scenarioElements/Scenario';
import {AssetTypes} from '../../globals';
import AnalyticsManager from '../../classes/AnalyticsManager';

export default function ModelTrackerModelPicker(props)
{
	const faceValue = props.sceneSelectionValue ? props.sceneSelectionValue : props.modelValue ? AssetUtility.getAssetName(props.modelValue) : "Select Model";
	const dataName = "ModelTrackerModelPicker";

	function onAssetChosen(assetId)
	{
		if (props.onAssetChangeCallback)
		{
			props.onAssetChangeCallback(assetId);
		}
	}

	function onSceneObjectsChosen(objects)
	{
		if (props.onSceneSelectionChangeCallback)
		{
			props.onSceneSelectionChangeCallback(objects);
		}
	}

	const modalId = useRef("");
	const oLayeredContent =
		<Panel>
			<TabbedDisplay value={props.sceneSelectionValue ? 1 : 0}>
				<div data-tabheader={"Asset Library"}>
					<AssetPicker
						data-name={dataName + "-picker"}
						type={AssetTypes.Model}
						extensionFilter={props.extensionFilter}
						value={props.modelValue}
						filtered={props.filtered}
						showRevisions={props.showRevisions}
						libraryOnly={props.libraryOnly}
						onShutdown={()=> ModalManager.removeModal(modalId.current)}
						assetSelectedCallback={(assetId) =>
						{
							AnalyticsManager.managedEvent('propertyChanged', 'propertyId', props["data-name"] ? props["data-name"] + "-asset" : "asset-property");
							onAssetChosen(assetId);
						}}
					/>
				</div>
				<div data-tabheader={"Content Placement Step"}>
					<SceneObjectPicker
						value={faceValue}
						data-name={dataName + "-scene-picker"}
						returnObjectGuid={false}
						multiSelectEnabled={true}
						renderPreview={true}
						sceneId={Scenario.currentStep()?.sequence.trackersStep.sceneId}
						onSelectedCallback={(id) =>
						{
							onSceneObjectsChosen(id);
						}}

						onShutdown={()=> ModalManager.removeModal(modalId.current)}
					/>
				</div>
			</TabbedDisplay>
		</Panel>;


	return(
		<div className={"layoutPanel horizontal centerContent assetPropertyWrapper"}>
			<PropertyBase {...props}
				data-name={dataName + "-root"}
				required={props.required && !props.modelValue}
			>
				<Button data-name={dataName + "-button"}
					silent={true}
					label={faceValue}
					disabled={props.readOnly}
					onClick={(e) =>
					{
						modalId.current = ModalManager.addModal({
							content: oLayeredContent
						});
					}}
				/>
			</PropertyBase>
		</div>
	);
}